const SHARED_CONVERSATION_ID_PREFIX = 'share-';

export const isSharedConversationId = (conversationId?: string): boolean =>
  conversationId?.startsWith(SHARED_CONVERSATION_ID_PREFIX) ?? false;

export const isPersistedConversationId = (
  conversationId?: string,
): conversationId is string =>
  conversationId !== undefined && !isSharedConversationId(conversationId);
